
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.552 44c2.831 0 4.96-.635 6.386-1.905 1.425-1.27 2.137-3.151 2.137-5.641V7.546c0-2.49-.712-4.37-2.138-5.64C45.513.635 43.385 0 40.553 0H8.524C5.71 0 3.587.631 2.152 1.893.717 3.155 0 5.039 0 7.546v28.908c0 2.507.717 4.391 2.152 5.653C3.587 43.37 5.71 44 8.524 44h32.028zm-.196-4.287H8.72c-1.249 0-2.213-.301-2.893-.903-.68-.602-1.02-1.496-1.02-2.682V7.872c0-1.186.34-2.08 1.02-2.682.68-.602 1.644-.903 2.893-.903h31.636c1.248 0 2.217.301 2.906.903.69.601 1.035 1.496 1.035 2.682v28.256c0 1.186-.345 2.08-1.035 2.682-.689.602-1.658.903-2.906.903zm-18.669-6.494c.95 0 1.705-.392 2.264-1.178l12.017-16.823c.15-.25.294-.51.433-.777.14-.267.21-.535.21-.802 0-.552-.238-.999-.713-1.342a2.638 2.638 0 00-1.579-.514c-.782 0-1.444.385-1.984 1.154L21.603 28.33l-5.03-5.817c-.317-.351-.638-.598-.964-.74a2.594 2.594 0 00-1.048-.213c-.634 0-1.16.197-1.58.59-.419.392-.628.864-.628 1.416 0 .518.223 1.036.67 1.554l6.317 6.92c.354.418.717.719 1.09.903.372.183.791.275 1.257.275z","fill":"#fff"}})])
          )
        }
      }
    